import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenCategoryNavigationComponent } from './category-navigation/category-navigation.component';
import { I18nModule } from "@spartacus/core";
import { GenericLinkModule, HamburgerMenuModule, IconModule } from "@spartacus/storefront";
import { GenSharedModule } from "../../../generac/shared/shared.module";
import { GenHeaderNavigationComponent } from "./header-navigation/header-navigation.component";
import { GenCategoryMenuComponent } from './category-menu/category-menu.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    GenericLinkModule,
    HamburgerMenuModule,
    GenSharedModule
  ],
  declarations: [GenCategoryNavigationComponent, GenHeaderNavigationComponent, GenCategoryMenuComponent],
  exports: [GenCategoryNavigationComponent, GenHeaderNavigationComponent]
})
export class GenCategoryNavigationModule { }
